// extracted by mini-css-extract-plugin
export var videoHero = "_br-4";
export var videoHeroImage = "_br-5";
export var videoHeroOverlay = "_br-6";
export var videoHeroSubtitle = "_br-8";
export var videoHeroText = "_br-7";
export var videoLauncher = "_br-0";
export var videoLauncherIcon = "_br-1";
export var videoLauncherSubtitle = "_br-3";
export var videoLauncherTitle = "_br-2";
export var videoPlayer = "_br-a";
export var videoPlayerWrap = "_br-9";